import { connectedStore } from '../../store';
import selectors from '../selectors';

const getSupportedLocales = () => {
  const store = connectedStore.get();
  const state = store.getState();

  return selectors.getSupportedLocales(state);
};

export default getSupportedLocales;
